//保存基本信息
import React from 'react';
import config from '../../../assets/js/conf/config.js';
import {request} from '../../../assets/js/libs/request.js';
import {getNowTime} from '../../../assets/js/utils/util.js';
import {connect} from 'react-redux';
import { Switch,Toast,Picker, DatePicker, List } from 'antd-mobile';
import '../../../assets/css/common/reg/index.css';
import {province} from '../../../assets/data/province.js';
import SubHeaderComponent from '../../../components/header/subheader';


const nowTimeStamp = Date.now();
const now = new Date(nowTimeStamp);
const minDate = new Date(1949, 1, 1, 0, 0, 0);
export default class LoginIndex extends React.Component{
    constructor(){
        super();
        this.state={
            'name':'',
            'pigField':'',
            'telInput': false,
            'textInput': false,
            'defaultProvince':"",
			"Birthday": now,
			"BirthdayType": 1,
			"SowsCount": 0
        };
        this.bSubmit=true;
    }
    componentDidMount(){
		
    }
    componentWillUnmount(){
        this.setState=(state,callback)=>{
            return;
        }
    }

    //点击登录按钮
    submitData(){
    	let that = this;
    	if(this.state.name == ''){
            Toast.info("请填写您的真实姓名!", 1);
            return false;
        }
        if(this.state.pigField == ''){
            Toast.info("请填写猪场名称！",1);
            return false;
        }
		if(this.state.SowsCount == '0'){
		    Toast.info("请填写母猪存栏数量！",1);
		    return false;
		}
        if (this.bSubmit){
            this.bSubmit=false;
            let sUrl = config.baseUrl+"api/Study/S007";
			let data = {
				'name':this.state.name, 
				'piggery':this.state.pigField, 
				'address':this.state.defaultProvince,
				"Birthday": getNowTime(this.state.Birthday),
				"BirthdayType": this.state.BirthdayType,
				"SowsCount": this.state.SowsCount
			};
			//console.log(data)
            request(sUrl, "post", data).then(res=>{
                Toast.info(res.message, 1);
				this.bSubmit = true;
				
                if(res && res.code == 0){
                	setTimeout(function(){
	                	that.pushPage('/home/index');
	                }, 1500)
                }
            });
        }
   }
    pushPage(url){
        this.props.history.replace(url)
    }
    //焦点事件
    inputOnFocus(flag){
    	if(flag == 'tel'){
    		this.setState({
	    		telInput: true
	    	})
    	}else{
    		this.setState({
	    		textInput: true
	    	})
    	}
    	
    }
    inputOnBlur(flag){
    	if(flag == 'tel'){
    		this.setState({
	    		telInput: false
	    	})
    	}else{
    		this.setState({
	    		textInput: false
	    	})
    	}
    	
    }
    render(){
        return (
            <div className={'page'}>
				<SubHeaderComponent title="基本信息"></SubHeaderComponent>
                <div className={'main login-main'} style={{'marginTop': '0.4rem'}}>
				{
					// <div class='OneMess' style={{'textAlign': 'center'}}>
					// 	<img src={require('../../../assets/images/video/logo.png')} />
					// </div>
				}
                    <h4 style={{'marginLeft': '8%', 'fontSize': '0.32rem'}}>
                    	请填写您的基本信息
                    </h4>
                    <div className={'cellphone-wrap'} style={{'marginTop': '0.7rem'}}>
                    	<div class='Onetext'>姓名</div>
                        <div className={'cellphone xinxi'}>
                        	<input type="text" placeholder="请填写您的真实姓名" 
                        		onChange={(e)=>{this.setState({name: e.target.value})}}
                        		onBlur={this.inputOnBlur.bind(this, 'tel')}
       							onFocus={this.inputOnFocus.bind(this, 'tel')}
                        	/>
                        </div>
                    </div>
					<div className={'cellphone-wrap'} style={{'marginTop': '0.7rem'}}>
						<div class='Onetext'>生日</div>
					    <div className={'cellphone xinxi'}>
							<List className="date-picker-list" style={{ backgroundColor: 'white' }}>
								<DatePicker
								  mode="date"
								  minDate={minDate}
								  title="请选择日期"
								  extra="Optional"
								  value={this.state.Birthday}
								  onChange={Birthday => this.setState({ Birthday })}
								>
								  <List.Item arrow="horizontal">请选择日期</List.Item>
								</DatePicker>
							</List>
							<div className={'BirthdayRedio'}>
								<p className={this.state.BirthdayType == 1?'active':''} onClick={BirthdayType => this.setState({ BirthdayType: 1 })}><span></span> 农历</p>
								<p className={this.state.BirthdayType == 2?'active':''} onClick={BirthdayType => this.setState({ BirthdayType: 2 })}><span></span> 公历</p>
							</div>
					    </div>
					</div>
                    <div className={'cellphone-wrap'} style={{'marginTop': '0.9rem'}}>
                    	<div class='Onetext'>猪场</div>
                        <div className={'cellphone xinxi'}>
                        	<input type="text" placeholder="请填写猪场名称" 
                        		onChange={(e)=>{this.setState({pigField: e.target.value})}}
                        		onBlur={this.inputOnBlur.bind(this, 'text')}
       							onFocus={this.inputOnFocus.bind(this, 'text')}
                        	/>
                        </div>
                    </div>
					<div className={'cellphone-wrap'} style={{'marginTop': '0.9rem'}}>
						<div class='Onetext'>规模(头)</div>
					    <div className={'cellphone xinxi'}>
					    	<input type="text" placeholder="请填写猪场名称" 
					    		onChange={(e)=>{this.setState({SowsCount: e.target.value})}}
					    		onBlur={this.inputOnBlur.bind(this, 'text')}
								onFocus={this.inputOnFocus.bind(this, 'text')}
					    	/>
					    </div>
					</div>
                    <div className={'cellphone-wrap'} style={{'marginTop': '0.9rem'}}>
                    	<div class='Onetext'>地址</div>
                        <div className={'cellphone xinxi'}>
                        	<Picker data={province} title="选择地区" onOk={e =>{
	                            this.setState({defaultProvince:e.join(" "),sProvince:e[0],sCity:e[1],sArea:e[2]!==undefined?e[2]:''});
	                        }}>
		                        <div>
		                            <input type="text" placeholder="请选择收货地址" className={'area'} readOnly value={this.state.defaultProvince} />
									<span className={'more'}></span>
		                        </div>
	                        </Picker>
                        </div>
                    </div>
                    <div className={'sure-btn'} onClick={this.submitData.bind(this)}>确认</div>
                </div>
            </div>
        )
    }
}
